//mobile services icons 
const appAgileIcon1 = '/assets/Icons/mobileServicesIcons/deployed-more-than-100-apps.svg';
const appAgileIcon2 = '/assets/Icons/mobileServicesIcons/onboard-skilled-developer-in-48-hours.svg';
const appAgileIcon3 = '/assets/Icons/mobileServicesIcons/expertise-with-various-integrations.svg';
const appAgileIcon4 = '/assets/Icons/mobileServicesIcons/hybrid-and-native-experience-developers.svg';

const MobileBenefitIcon1 = '/assets/Icons/mobileServicesIcons/cost-effective-solutions.svg'
const MobileBenefitIcon2 = '/assets/Icons/mobileServicesIcons/enhanced-user-experience.svg'
const MobileBenefitIcon3 = '/assets/Icons/mobileServicesIcons/seamless-integration.svg'
const MobileBenefitIcon4 = '/assets/Icons/mobileServicesIcons/market-expansion.svg'
const MobileBenefitIcon5 = '/assets/Icons/mobileServicesIcons/strong-brand-presence.svg'
const MobileBenefitIcon6 = '/assets/Icons/mobileServicesIcons/real-time-data-access.svg'

const mobileServiceIcon1 = '/assets/Icons/mobileServicesIcons/android-app-development.svg'
const mobileServiceIcon2 = '/assets/Icons/mobileServicesIcons/ios-app-development.svg'
const mobileServiceIcon3 = '/assets/Icons/mobileServicesIcons/on-demand-app-development.svg'
const mobileServiceIcon4 = '/assets/Icons/mobileServicesIcons/enterprise-app-development.svg'
const mobileServiceIcon5 = '/assets/Icons/mobileServicesIcons/flutter-app-development.svg'
const mobileServiceIcon6 = '/assets/Icons/mobileServicesIcons/react-native-app-development.svg'
const mobileServiceIcon7 = '/assets/Icons/mobileServicesIcons/native-mobile-app-development.svg'
const mobileServiceIcon8 = '/assets/Icons/mobileServicesIcons/cross-platform-app-development.svg'
const mobileServiceIcon9 = '/assets/Icons/mobileServicesIcons/e-commerce-app-development.svg'
const mobileServiceIcon10 = '/assets/Icons/mobileServicesIcons/progressive-web-app-development.svg'
const mobileServiceIcon11 = '/assets/Icons/mobileServicesIcons/iot-app-development.svg'
const mobileServiceIcon12 = '/assets/Icons/mobileServicesIcons/wearable-app-development.svg'
const mobileServiceIcon13 = '/assets/Icons/mobileServicesIcons/ar-vr-app-development.svg'
const mobileServiceIcon14 = '/assets/Icons/mobileServicesIcons/app-migration-and-modernization.svg'


//web services icons 
const webAgileIcon1 = '/assets/Icons/webServicesIcons/deployed-more-than-250-web-solutions.svg';
const webAgileIcon2 = '/assets/Icons/webServicesIcons/onboard-skilled-developer-in-48-hours.svg';
const webAgileIcon3 = '/assets/Icons/webServicesIcons/expertise-with-saas-based-platforms.svg';
const webAgileIcon4 = '/assets/Icons/webServicesIcons/24x7-maintenance-and-support.svg';

const webBenefitIcon1 = '/assets/Icons/webServicesIcons/customized-solutions.svg'
const webBenefitIcon2 = '/assets/Icons/webServicesIcons/enhanced-user-experience.svg'
const webBenefitIcon3 = '/assets/Icons/webServicesIcons/scalability-and-flexibility.svg'
const webBenefitIcon4 = '/assets/Icons/webServicesIcons/customizable-features-and-integrations.svg'
const webBenefitIcon5 = '/assets/Icons/webServicesIcons/mobile-responsive-design.svg'
const webBenefitIcon6 = '/assets/Icons/webServicesIcons/cost-effective-and-time-efficient.svg'

const webServiceIcon1 = '/assets/Icons/webServicesIcons/custom-web-app-development.svg'
const webServiceIcon2 = '/assets/Icons/webServicesIcons/web-portal-development.svg'
const webServiceIcon3 = '/assets/Icons/webServicesIcons/progressive-web-applications.svg'
const webServiceIcon4 = '/assets/Icons/webServicesIcons/enterprise-web-development.svg'
const webServiceIcon5 = '/assets/Icons/webServicesIcons/frontend-development.svg'
const webServiceIcon6 = '/assets/Icons/webServicesIcons/backend-development.svg'
const webServiceIcon7 = '/assets/Icons/webServicesIcons/full-stack-development.svg'
const webServiceIcon8 = '/assets/Icons/webServicesIcons/website-development.svg'
const webServiceIcon9 = '/assets/Icons/webServicesIcons/cms-development.svg'
const webServiceIcon10 = '/assets/Icons/webServicesIcons/e-commerce-platform-development.svg'
const webServiceIcon11 = '/assets/Icons/webServicesIcons/api-development-and-integration.svg'
const webServiceIcon12 = '/assets/Icons/webServicesIcons/website-maintenance-and-support.svg'

// custom services
const customAgileIcon1 = '/assets/Icons/CustomServicesIcons/deployed-more-than-100-custom-solutions.svg';
const customAgileIcon2 = '/assets/Icons/CustomServicesIcons/competency-to-develop-everything.svg';
const customAgileIcon3 = '/assets/Icons/CustomServicesIcons/desired-outcomes-with-high-quality-solutions.svg';
const customAgileIcon4 = '/assets/Icons/CustomServicesIcons/various-engagement-models-for-clients.svg';

const customBenefitIcon1 = '/assets/Icons/CustomServicesIcons/tailored-it-solutions.svg';
const customBenefitIcon2 = '/assets/Icons/CustomServicesIcons/flexibility-and-scalability.svg';
const customBenefitIcon3 = '/assets/Icons/CustomServicesIcons/cost-effectiveness.svg';
const customBenefitIcon4 = '/assets/Icons/CustomServicesIcons/security-and-reliability.svg';
const customBenefitIcon5 = '/assets/Icons/CustomServicesIcons/seamless-integration.svg';
const customBenefitIcon6 = '/assets/Icons/CustomServicesIcons/support-and-maintenance.svg';

const customServiceIcon1 = '/assets/Icons/CustomServicesIcons/custom-software-development.svg';
const customServiceIcon2 = '/assets/Icons/CustomServicesIcons/web-development.svg';
const customServiceIcon3 = '/assets/Icons/CustomServicesIcons/mobile-app-development.svg';
const customServiceIcon4 = '/assets/Icons/CustomServicesIcons/dedicated-development-team.svg';
const customServiceIcon5 = '/assets/Icons/CustomServicesIcons/product-development.svg';
const customServiceIcon6 = '/assets/Icons/CustomServicesIcons/e-commerce-development.svg';
const customServiceIcon7 = '/assets/Icons/CustomServicesIcons/ui-ux-design.svg';
const customServiceIcon8 = '/assets/Icons/CustomServicesIcons/software-testing-and-quality-assurance.svg';


// blockchain services
const blockchainAgileIcon1 = '/assets/Icons/blockChainServicesIcons/deployed-more-than-60-blockchain-solutions.svg';
const blockchainAgileIcon2 = '/assets/Icons/blockChainServicesIcons/expertise-with-all-blockchain-platforms.svg';
const blockchainAgileIcon3 = '/assets/Icons/blockChainServicesIcons/experience-with-all-decentralized-ecosystems.svg';
const blockchainAgileIcon4 = '/assets/Icons/blockChainServicesIcons/implemented-blockchain-solution-for-many-domains.svg';

const blockchainBenefitIcon1 = '/assets/Icons/blockChainServicesIcons/cost-optimization-and-high-return-on-investment.svg';
const blockchainBenefitIcon2 = '/assets/Icons/blockChainServicesIcons/unmatched-security-and-data-protection.svg';
const blockchainBenefitIcon3 = '/assets/Icons/blockChainServicesIcons/seamless-integration-into-existing-systems.svg';
const blockchainBenefitIcon4 = '/assets/Icons/blockChainServicesIcons/expansion-of-market-reach-and-business-growth.svg';
const blockchainBenefitIcon5 = '/assets/Icons/blockChainServicesIcons/enhancement-of-brand-credibility.svg';
const blockchainBenefitIcon6 = '/assets/Icons/blockChainServicesIcons/real-time-analytics-and-intelligent-data-management.svg';

const blockchainServiceIcon1 = '/assets/Icons/blockChainServicesIcons/blockchain-strategy-and-consulting.svg';
const blockchainServiceIcon2 = '/assets/Icons/blockChainServicesIcons/custom-blockchain-solutions.svg';
const blockchainServiceIcon3 = '/assets/Icons/blockChainServicesIcons/blockchain-protocol-development.svg';
const blockchainServiceIcon4 = '/assets/Icons/blockChainServicesIcons/enterprise-blockchain-solutions.svg';
const blockchainServiceIcon5 = '/assets/Icons/blockChainServicesIcons/decentralized-app-development.svg';
const blockchainServiceIcon6 = '/assets/Icons/blockChainServicesIcons/decentralized-finance-solutions-and-development.svg';
const blockchainServiceIcon7 = '/assets/Icons/blockChainServicesIcons/dao-implementation-and-development.svg';
const blockchainServiceIcon8 = '/assets/Icons/blockChainServicesIcons/nft-marketplace-development.svg';
const blockchainServiceIcon9 = '/assets/Icons/blockChainServicesIcons/tokenization-and-digital-asset-development.svg';
const blockchainServiceIcon10 = '/assets/Icons/blockChainServicesIcons/smart-contract-design-and-development.svg';
const blockchainServiceIcon11 = '/assets/Icons/blockChainServicesIcons/custom-blockchain-app-development.svg';
const blockchainServiceIcon12 = '/assets/Icons/blockChainServicesIcons/cryptocurrency-exchange-development.svg';
const blockchainServiceIcon13 = '/assets/Icons/blockChainServicesIcons/initial-coin-offering-and-token-development.svg';
const blockchainServiceIcon14 = '/assets/Icons/blockChainServicesIcons/cryptocurrency-wallet-development.svg';
const blockchainServiceIcon15 = '/assets/Icons/blockChainServicesIcons/solidity-and-ethereum-development.svg';



// Enterprise
const enterpriseAgileIcon1 = '/assets/Icons/enterpricesServicesIcons/developed-and-maintained-many-enterprise-solutions.svg';
const enterpriseAgileIcon2 = '/assets/Icons/enterpricesServicesIcons/modernization-of-enterprise-solutions.svg';
const enterpriseAgileIcon3 = '/assets/Icons/enterpricesServicesIcons/hire-experts-for-enterprise-solutions.svg';
const enterpriseAgileIcon4 = '/assets/Icons/enterpricesServicesIcons/24x7-technical-support.svg';

const enterpriseBenefitIcon1 = '/assets/Icons/enterpricesServicesIcons/operational-excellence.svg';
const enterpriseBenefitIcon2 = '/assets/Icons/enterpricesServicesIcons/data-driven-decisions.svg';
const enterpriseBenefitIcon3 = '/assets/Icons/enterpricesServicesIcons/enhanced-security.svg';
const enterpriseBenefitIcon4 = '/assets/Icons/enterpricesServicesIcons/scalability.svg';
const enterpriseBenefitIcon5 = '/assets/Icons/enterpricesServicesIcons/cost-efficiency.svg';
const enterpriseBenefitIcon6 = '/assets/Icons/enterpricesServicesIcons/system-integration.svg';

const enterpriseServiceIcon1 = '/assets/Icons/enterpricesServicesIcons/enterprise-software-consulting.svg';
const enterpriseServiceIcon2 = '/assets/Icons/enterpricesServicesIcons/custom-enterprise-software-development.svg';
const enterpriseServiceIcon3 = '/assets/Icons/enterpricesServicesIcons/enterprise-mobile-app-development.svg';
const enterpriseServiceIcon4 = '/assets/Icons/enterpricesServicesIcons/enterprise-web-development.svg';
const enterpriseServiceIcon5 = '/assets/Icons/enterpricesServicesIcons/software-integration-services.svg';
const enterpriseServiceIcon6 = '/assets/Icons/enterpricesServicesIcons/legacy-application-modernization.svg';
const enterpriseServiceIcon7 = '/assets/Icons/enterpricesServicesIcons/enterprise-data-management.svg';
const enterpriseServiceIcon8 = '/assets/Icons/enterpricesServicesIcons/enterprise-mobility-services.svg'
const enterpriseServiceIcon9 = '/assets/Icons/enterpricesServicesIcons/enterprise-software-testing.svg';
const enterpriseServiceIcon10 = '/assets/Icons/enterpricesServicesIcons/digital-transformation-services.svg';
const enterpriseServiceIcon11 = '/assets/Icons/enterpricesServicesIcons/cybersecurity-services.svg';
const enterpriseServiceIcon12 = '/assets/Icons/enterpricesServicesIcons/application-maintenance-and-support.svg';




// AI/ML
const aiMlAgileIcon1 = '/assets/Icons/AIMLServicesIcons/ai-powered-cybersecurity-solutions.svg';
const aiMlAgileIcon2 = '/assets/Icons/AIMLServicesIcons/expertise-with-gen-ai-solutions.svg'
const aiMlAgileIcon3 = '/assets/Icons/AIMLServicesIcons/integrated-multiple-virtual-assistants.svg';
const aiMlAgileIcon4 = '/assets/Icons/AIMLServicesIcons/expertise-in-data-analytics-and-modeling.svg';

const aiMlBenefitIcon1 = '/assets/Icons/AIMLServicesIcons/cost-effective-scalable-solutions.svg';
const aiMlBenefitIcon2 = '/assets/Icons/AIMLServicesIcons/enhanced-user-experience.svg';
const aiMlBenefitIcon3 = '/assets/Icons/AIMLServicesIcons/seamless-ai-integration.svg';
const aiMlBenefitIcon4 = '/assets/Icons/AIMLServicesIcons/data-driven-market-expansion.svg';
const aiMlBenefitIcon5 = '/assets/Icons/AIMLServicesIcons/stronger-brand-engagement.svg';
const aiMlBenefitIcon6 = '/assets/Icons/AIMLServicesIcons/real-time-analytics-and-predictive-insights.svg';

const aiMlServiceIcon1 = '/assets/Icons/AIMLServicesIcons/ai-ml-consulting.svg';
const aiMlServiceIcon2 = '/assets/Icons/AIMLServicesIcons/machine-learning-model-development.svg';
const aiMlServiceIcon3 = '/assets/Icons/AIMLServicesIcons/natural-language-processing-solutions.svg';
const aiMlServiceIcon4 = '/assets/Icons/AIMLServicesIcons/generative-ai-and-deep-learning.svg';
const aiMlServiceIcon5 = '/assets/Icons/AIMLServicesIcons/ai-product-development-and-integration.svg';
const aiMlServiceIcon6 = '/assets/Icons/AIMLServicesIcons/ai-powered-chatbots-and-virtual-assistants.svg';
const aiMlServiceIcon7 = '/assets/Icons/AIMLServicesIcons/ai-driven-data-analytics-and-forecasting.svg';
const aiMlServiceIcon8 = '/assets/Icons/AIMLServicesIcons/ai-and-ml-solutions-for-automation.svg';
const aiMlServiceIcon9 = '/assets/Icons/AIMLServicesIcons/computer-vision-and-image-recognition.svg';
const aiMlServiceIcon10 = '/assets/Icons/AIMLServicesIcons/ai-ml-for-personalized-recommendations.svg';
const aiMlServiceIcon11 = '/assets/Icons/AIMLServicesIcons/ai-enabled-fraud-detection.svg';
const aiMlServiceIcon12 = '/assets/Icons/AIMLServicesIcons/ai-ml-powered-cybersecurity-solutions.svg';


// IoT
const iotAgileIcon1 = '/assets/Icons/IOTServicesIcons/integrated-iot-in-various-domains.svg';
const iotAgileIcon2 = '/assets/Icons/IOTServicesIcons/competency-with-hardware-communications.svg';
const iotAgileIcon3 = '/assets/Icons/IOTServicesIcons/worked-on-many-digital-twins-projects.svg';
const iotAgileIcon4 = '/assets/Icons/IOTServicesIcons/experience-in-aiot.svg';

const iotBenefitIcon1 = '/assets/Icons/IOTServicesIcons/cost-effective-iot-solutions.svg';
const iotBenefitIcon2 = '/assets/Icons/IOTServicesIcons/enhanced-user-experience.svg';
const iotBenefitIcon3 = '/assets/Icons/IOTServicesIcons/effortless-system-integration.svg';
const iotBenefitIcon4 = '/assets/Icons/IOTServicesIcons/scalability-and-flexibility.svg';
const iotBenefitIcon5 = '/assets/Icons/IOTServicesIcons/strengthened-brand-presence.svg';
const iotBenefitIcon6 = '/assets/Icons/IOTServicesIcons/real-time-data-access.svg';

const iotServiceIcon1 = '/assets/Icons/IOTServicesIcons/iot-consulting-services.svg'
const iotServiceIcon2 = '/assets/Icons/IOTServicesIcons/iot-software-development.svg';
const iotServiceIcon3 = '/assets/Icons/IOTServicesIcons/iot-mobile-application-development.svg';
const iotServiceIcon4 = '/assets/Icons/IOTServicesIcons/iot-web-application-development.svg';
const iotServiceIcon5 = '/assets/Icons/IOTServicesIcons/iot-wearable-application-development-services.svg';
const iotServiceIcon6 = '/assets/Icons/IOTServicesIcons/artificial-intelligence-of-things.svg';
const iotServiceIcon7 = '/assets/Icons/IOTServicesIcons/iot-integration-and-implementation.svg';
const iotServiceIcon8 = '/assets/Icons/IOTServicesIcons/iot-product-development.svg';
const iotServiceIcon9 = '/assets/Icons/IOTServicesIcons/industrial-iot-services-and-solutions.svg';
const iotServiceIcon10 = '/assets/Icons/IOTServicesIcons/iot-application-upgrade-and-modernization.svg';
const iotServiceIcon11 = '/assets/Icons/IOTServicesIcons/iot-application-management-and-support.svg'

// Cloud
const cloudAgileIcon1 = '/assets/Icons/CloudServicesIcons/partner-with-aws-and-azure.svg';
const cloudAgileIcon2 = '/assets/Icons/CloudServicesIcons/get-certified-cloud-developers.svg';
const cloudAgileIcon3 = '/assets/Icons/CloudServicesIcons/easily-migrate-your-platform.svg';
const cloudAgileIcon4 = '/assets/Icons/CloudServicesIcons/expertise-in-reducing-the-cost.svg';

const cloudBenefitIcon1 = '/assets/Icons/CloudServicesIcons/scalability.svg';
const cloudBenefitIcon2 = '/assets/Icons/CloudServicesIcons/cost-efficiency.svg';
const cloudBenefitIcon3 = '/assets/Icons/CloudServicesIcons/enhanced-security.svg';
const cloudBenefitIcon4 = '/assets/Icons/CloudServicesIcons/business-continuity.svg';
const cloudBenefitIcon5 = '/assets/Icons/CloudServicesIcons/accelerated-time-to-market.svg';
const cloudBenefitIcon6 = '/assets/Icons/CloudServicesIcons/seamless-integration.svg';

const cloudServiceIcon1 = '/assets/Icons/CloudServicesIcons/cloud-strategy-and-consulting.svg';
const cloudServiceIcon2 = '/assets/Icons/CloudServicesIcons/cloud-app-development.svg';
const cloudServiceIcon3 = '/assets/Icons/CloudServicesIcons/cloud-migration.svg';
const cloudServiceIcon4 = '/assets/Icons/CloudServicesIcons/cloud-integration.svg';
const cloudServiceIcon5 = '/assets/Icons/CloudServicesIcons/cloud-native-development.svg';
const cloudServiceIcon6 = '/assets/Icons/CloudServicesIcons/cloud-based-saas-development.svg';
const cloudServiceIcon7 = '/assets/Icons/CloudServicesIcons/cloud-security-and-risk-management.svg';
const cloudServiceIcon8 = '/assets/Icons/CloudServicesIcons/managed-cloud-services.svg';
const cloudServiceIcon9 = '/assets/Icons/CloudServicesIcons/cloud-computing-architecture.svg';
const cloudServiceIcon10 = '/assets/Icons/CloudServicesIcons/cloud-app-containerization.svg';
const cloudServiceIcon11 = '/assets/Icons/CloudServicesIcons/cloud-infrastructure-management.svg';
const cloudServiceIcon12 = '/assets/Icons/CloudServicesIcons/cloud-deployment.svg';
const cloudServiceIcon13 = '/assets/Icons/CloudServicesIcons/cloud-support-and-maintenance.svg';

// E-commerce
const ecommerceAgileIcon1 = '/assets/Icons/ECommerceServices/experience-with-all-cms-platform.svg';
const ecommerceAgileIcon2 = '/assets/Icons/ECommerceServices/developed-and-customized-inventory-system.svg';
const ecommerceAgileIcon3 = '/assets/Icons/ECommerceServices/expertise-with-3rd-party-integrations.svg';
const ecommerceAgileIcon4 = '/assets/Icons/ECommerceServices/24x7-support-and-delivery-integrations.svg';

const ecommerceBenefitIcon1 = '/assets/Icons/ECommerceServices/cost-effective-and-scalable-solutions.svg';
const ecommerceBenefitIcon2 = '/assets/Icons/ECommerceServices/optimized-user-experience.svg';
const ecommerceBenefitIcon3 = '/assets/Icons/ECommerceServices/seamless-integrations.svg';
const ecommerceBenefitIcon4 = '/assets/Icons/ECommerceServices/mobile-first-solutions.svg';
const ecommerceBenefitIcon5 = '/assets/Icons/ECommerceServices/strengthened-brand-visibility-brand-presence.svg';
const ecommerceBenefitIcon6 = '/assets/Icons/ECommerceServices/data-driven-decision-making-time-data-access.svg';

const ecommerceServiceIcon1 = '/assets/Icons/ECommerceServices/e-commerce-consulting.svg';
const ecommerceServiceIcon2 = '/assets/Icons/ECommerceServices/e-commerce-mobile-app-development.svg';
const ecommerceServiceIcon3 = '/assets/Icons/ECommerceServices/e-commerce-front-end-development.svg';
const ecommerceServiceIcon4 = '/assets/Icons/ECommerceServices/e-commerce-back-end-development.svg';
const ecommerceServiceIcon5 = '/assets/Icons/ECommerceServices/e-commerce-website-design-and-development.svg';
const ecommerceServiceIcon6 = '/assets/Icons/ECommerceServices/e-commerce-integration.svg';
const ecommerceServiceIcon7 = '/assets/Icons/ECommerceServices/platform-based-development-app-development.svg';
const ecommerceServiceIcon8 = '/assets/Icons/ECommerceServices/e-commerce-migration-and-upgrades.svg';
const ecommerceServiceIcon9 = '/assets/Icons/ECommerceServices/e-commerce-support-and-optimization.svg';

// Staff Augmentation
const staffAgileIcon1 = '/assets/Icons/itStaffServicesIcons/on-demand-resources.svg';
const staffAgileIcon2 = '/assets/Icons/itStaffServicesIcons/hire-a-team-based-on-requirement.svg';
const staffAgileIcon3 = '/assets/Icons/itStaffServicesIcons/feasibility-to-work-remotely-or-onsite.svg';
const staffAgileIcon4 = '/assets/Icons/itStaffServicesIcons/flexible-it-staffing-engagement-models.svg';

const staffBenefitIcon1 = '/assets/Icons/itStaffServicesIcons/access-to-expertise.svg';
const staffBenefitIcon2 = '/assets/Icons/itStaffServicesIcons/cost-efficiency.svg';
const staffBenefitIcon3 = '/assets/Icons/itStaffServicesIcons/scalability.svg';
const staffBenefitIcon4 = '/assets/Icons/itStaffServicesIcons/faster-time-to-market.svg';
const staffBenefitIcon5 = '/assets/Icons/itStaffServicesIcons/focus-on-core-business.svg';
const staffBenefitIcon6 = '/assets/Icons/itStaffServicesIcons/reduced-operational-overhead.svg';

const staffServiceIcon1 = '/assets/Icons/itStaffServicesIcons/short-term-and-long-term-it-staffing.svg';
const staffServiceIcon2 = '/assets/Icons/itStaffServicesIcons/dedicated-development-teams.svg';
const staffServiceIcon3 = '/assets/Icons/itStaffServicesIcons/full-time-and-part-time-it-professionals.svg';
const staffServiceIcon4 = '/assets/Icons/itStaffServicesIcons/on-demand-it-experts-for-critical-projects.svg';
const staffServiceIcon5 = '/assets/Icons/itStaffServicesIcons/remote-and-on-site-it-staffing-solutions.svg';
const staffServiceIcon6 = '/assets/Icons/itStaffServicesIcons/on-demand-staff-augmentation.svg';


// Managed IT
const managedAgileIcon1 = '/assets/Icons/managedITServicesIcons/multi-cloud-hybrid-it-infrastructure-managed-services.svg';
const managedAgileIcon2 = '/assets/Icons/managedITServicesIcons/managed-backup-and-business-continuity.svg';
const managedAgileIcon3 = '/assets/Icons/managedITServicesIcons/managed-it-security-services.svg';
const managedAgileIcon4 = '/assets/Icons/managedITServicesIcons/application-managed-services.svg';

const managedBenefitIcon1 = '/assets/Icons/managedITServicesIcons/cost-savings.svg';
const managedBenefitIcon2 = '/assets/Icons/managedITServicesIcons/expertise.svg';
const managedBenefitIcon3 = '/assets/Icons/managedITServicesIcons/proactive-maintenance.svg';
const managedBenefitIcon4 = '/assets/Icons/managedITServicesIcons/enhanced-security.svg';
const managedBenefitIcon5 = '/assets/Icons/managedITServicesIcons/business-continuity.svg';
const managedBenefitIcon6 = '/assets/Icons/managedITServicesIcons/scalability-and-flexibility.svg';

const managedServiceIcon1 = '/assets/Icons/managedITServicesIcons/managed-infrastructure-and-application-monitoring.svg';
const managedServiceIcon2 = '/assets/Icons/managedITServicesIcons/managed-services-desk.svg';
const managedServiceIcon3 = '/assets/Icons/managedITServicesIcons/multi-cloud-and-hybrid-infrastructure-manage-services.svg';
const managedServiceIcon4 = '/assets/Icons/managedITServicesIcons/help-desk-support.svg';
const managedServiceIcon5 = '/assets/Icons/managedITServicesIcons/non-compute-managed-services.svg';
const managedServiceIcon6 = '/assets/Icons/managedITServicesIcons/application-managed-support-services.svg';
const managedServiceIcon7 = '/assets/Icons/managedITServicesIcons/managed-security-services.svg';
const managedServiceIcon8 = '/assets/Icons/managedITServicesIcons/database-managed-services.svg';


export const icons = {
    appAgileIcon1,
    appAgileIcon2,
    appAgileIcon3,
    appAgileIcon4,
    MobileBenefitIcon1,
    MobileBenefitIcon2,
    MobileBenefitIcon3,
    MobileBenefitIcon4,
    MobileBenefitIcon5,
    MobileBenefitIcon6,
    mobileServiceIcon1,
    mobileServiceIcon2,
    mobileServiceIcon3,
    mobileServiceIcon4,
    mobileServiceIcon5,
    mobileServiceIcon6,
    mobileServiceIcon7,
    mobileServiceIcon8,
    mobileServiceIcon9,
    mobileServiceIcon10,
    mobileServiceIcon11,
    mobileServiceIcon12,
    mobileServiceIcon13,
    mobileServiceIcon14,
    //webservices
    webAgileIcon1,
    webAgileIcon2,
    webAgileIcon3,
    webAgileIcon4,
    webBenefitIcon1,
    webBenefitIcon2,
    webBenefitIcon3,
    webBenefitIcon4,
    webBenefitIcon5,
    webBenefitIcon6,
    webServiceIcon1,
    webServiceIcon2,
    webServiceIcon3,
    webServiceIcon4,
    webServiceIcon5,
    webServiceIcon6,
    webServiceIcon7,
    webServiceIcon8,
    webServiceIcon9,
    webServiceIcon10,
    webServiceIcon11,
    webServiceIcon12,

    //custom services 
    customAgileIcon1,
    customAgileIcon2,
    customAgileIcon3,
    customAgileIcon4,
    customBenefitIcon1,
    customBenefitIcon2,
    customBenefitIcon3,
    customBenefitIcon4,
    customBenefitIcon5,
    customBenefitIcon6,
    customServiceIcon1,
    customServiceIcon2,
    customServiceIcon3,
    customServiceIcon4,
    customServiceIcon5,
    customServiceIcon6,
    customServiceIcon7,
    customServiceIcon8,


    //bloackchain 
    blockchainAgileIcon1,
    blockchainAgileIcon2,
    blockchainAgileIcon3,
    blockchainAgileIcon4,
    blockchainBenefitIcon1,
    blockchainBenefitIcon2,
    blockchainBenefitIcon3,
    blockchainBenefitIcon4,
    blockchainBenefitIcon5,
    blockchainBenefitIcon6,
    blockchainServiceIcon1,
    blockchainServiceIcon2,
    blockchainServiceIcon3,
    blockchainServiceIcon4,
    blockchainServiceIcon5,
    blockchainServiceIcon6,
    blockchainServiceIcon7,
    blockchainServiceIcon8,
    blockchainServiceIcon9,
    blockchainServiceIcon10,
    blockchainServiceIcon11,
    blockchainServiceIcon12,
    blockchainServiceIcon13,
    blockchainServiceIcon14,
    blockchainServiceIcon15,
    // enterprise
    enterpriseAgileIcon1,
    enterpriseAgileIcon2,
    enterpriseAgileIcon3,
    enterpriseAgileIcon4,
    enterpriseBenefitIcon1,
    enterpriseBenefitIcon2,
    enterpriseBenefitIcon3,
    enterpriseBenefitIcon4,
    enterpriseBenefitIcon5,
    enterpriseBenefitIcon6,
    enterpriseServiceIcon1,
    enterpriseServiceIcon2,
    enterpriseServiceIcon3,
    enterpriseServiceIcon4,
    enterpriseServiceIcon5,
    enterpriseServiceIcon6,
    enterpriseServiceIcon7,
    enterpriseServiceIcon8,
    enterpriseServiceIcon9,
    enterpriseServiceIcon10,
    enterpriseServiceIcon11,
    enterpriseServiceIcon12,

    // aiMl
    aiMlAgileIcon1,
    aiMlAgileIcon2,
    aiMlAgileIcon3,
    aiMlAgileIcon4,
    aiMlBenefitIcon1,
    aiMlBenefitIcon2,
    aiMlBenefitIcon3,
    aiMlBenefitIcon4,
    aiMlBenefitIcon5,
    aiMlBenefitIcon6,
    aiMlServiceIcon1,
    aiMlServiceIcon2,
    aiMlServiceIcon3,
    aiMlServiceIcon4,
    aiMlServiceIcon5,
    aiMlServiceIcon6,
    aiMlServiceIcon7,
    aiMlServiceIcon8,
    aiMlServiceIcon9,
    aiMlServiceIcon10,
    aiMlServiceIcon11,
    aiMlServiceIcon12,

    // IoT
    iotAgileIcon1,
    iotAgileIcon2,
    iotAgileIcon3,
    iotAgileIcon4,
    iotBenefitIcon1,
    iotBenefitIcon2,
    iotBenefitIcon3,
    iotBenefitIcon4,
    iotBenefitIcon5,
    iotBenefitIcon6,
    iotServiceIcon1,
    iotServiceIcon2,
    iotServiceIcon3,
    iotServiceIcon4,
    iotServiceIcon5,
    iotServiceIcon6,
    iotServiceIcon7,
    iotServiceIcon8,
    iotServiceIcon9,
    iotServiceIcon10,
    iotServiceIcon11,


    // Cloud
    cloudAgileIcon1,
    cloudAgileIcon2,
    cloudAgileIcon3,
    cloudAgileIcon4,
    cloudBenefitIcon1,
    cloudBenefitIcon2,
    cloudBenefitIcon3,
    cloudBenefitIcon4,
    cloudBenefitIcon5,
    cloudBenefitIcon6,
    cloudServiceIcon1,
    cloudServiceIcon2,
    cloudServiceIcon3,
    cloudServiceIcon4,
    cloudServiceIcon5,
    cloudServiceIcon6,
    cloudServiceIcon7,
    cloudServiceIcon8,
    cloudServiceIcon9,
    cloudServiceIcon10,
    cloudServiceIcon11,
    cloudServiceIcon12,
    cloudServiceIcon13,

    // E-commerce
    ecommerceAgileIcon1,
    ecommerceAgileIcon2,
    ecommerceAgileIcon3,
    ecommerceAgileIcon4,
    ecommerceBenefitIcon1,
    ecommerceBenefitIcon2,
    ecommerceBenefitIcon3,
    ecommerceBenefitIcon4,
    ecommerceBenefitIcon5,
    ecommerceBenefitIcon6,
    ecommerceServiceIcon1,
    ecommerceServiceIcon2,
    ecommerceServiceIcon3,
    ecommerceServiceIcon4,
    ecommerceServiceIcon5,
    ecommerceServiceIcon6,
    ecommerceServiceIcon7,
    ecommerceServiceIcon8,
    ecommerceServiceIcon9,


    // Staff Augmentation
    staffAgileIcon1,
    staffAgileIcon2,
    staffAgileIcon3,
    staffAgileIcon4,
    staffBenefitIcon1,
    staffBenefitIcon2,
    staffBenefitIcon3,
    staffBenefitIcon4,
    staffBenefitIcon5,
    staffBenefitIcon6,
    staffServiceIcon1,
    staffServiceIcon2,
    staffServiceIcon3,
    staffServiceIcon4,
    staffServiceIcon5,
    staffServiceIcon6,

    // Managed IT
    managedAgileIcon1,
    managedAgileIcon2,
    managedAgileIcon3,
    managedAgileIcon4,
    managedBenefitIcon1,
    managedBenefitIcon2,
    managedBenefitIcon3,
    managedBenefitIcon4,
    managedBenefitIcon5,
    managedBenefitIcon6,
    managedServiceIcon1,
    managedServiceIcon2,
    managedServiceIcon3,
    managedServiceIcon4,
    managedServiceIcon5,
    managedServiceIcon6,
    managedServiceIcon7,
    managedServiceIcon8,
};
